<template>
  <div>
    <template v-if="initialLoad">
      <v-content color="primary" v-if="valid">
        <v-container fill-height fluid>
          <v-layout row wrap>
            <div class="login-overlay">
              <div class="login-inner">
                <img
                  :src="publicPath + 'img/logo-vote.png'"
                  @click="logoClick"
                  style="width: 100%; max-width: 300px; cursor: pointer"
                />
                <v-flex xs12>
                  <v-text-field
                    :label="$t('fields.new_password_1')"
                    @keyup.native.enter="loginClick"
                    outline
                    type="password"
                    v-model="resetData.password_1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('fields.new_password_2')"
                    @keyup.native.enter="loginClick"
                    outline
                    type="password"
                    v-model="resetData.password_2"
                  ></v-text-field>
                </v-flex>
                <v-flex class="mt-5" xs12>
                  <v-layout row wrap>
                    <v-spacer></v-spacer>
                    <v-btn @click="resetClick" color="primary"
                      >{{ $t('loginScreen.reset') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>
              </div>
            </div>
          </v-layout>
        </v-container>
      </v-content>
      <v-content v-if="!valid">
        <v-container fill-height fluid>
          <v-layout align-center justify-center>
            <v-flex md4 sm8 xs12>
              <p class="headline text-xs-center">
                {{ $t('ballot.wrongTokenPreview') }}
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </template>
  </div>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'PasswordReset',
  props: ['token'],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      initialLoad: false,
      valid: false,
      resetData: {
        password_1: '',
        password_2: '',
      },
    }
  },
  methods: {
    resetClick() {
      let message = ''
      if (this.resetData.password_1 == '') {
        message += this.$t('alerts.newPasswordMissing') + '<br />'
      } else if (this.resetData.password_1.length < 8) {
        message += this.$t('alerts.passwordLength') + '<br />'
      } else if (this.resetData.password_1.includes(' ')) {
        message += this.$t('alerts.passwordSpaces') + '<br />'
      } else if (this.resetData.password_1 != this.resetData.password_2) {
        message += this.$t('alerts.passwordMatch') + '<br />'
      }
      if (message == '') {
        var vm = this
        this.$APICall(
          'post',
          'PASSWORD_RESET',
          '/action/' + this.$route.params.token,
          this.resetData,
          function (data) {
            if (data.success) {
              vm.$alert(vm.$t('alerts.passwordChangeSuccess'))
              vm.$router.push({ name: 'Login' })
            } else {
              vm.$alert(vm.$t('alerts.passwordChangeError'))
            }
          },
          false,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
    logoClick() {
      window.open('https://fair-votes.com')
    },
  },
  mounted() {
    let vm = this
    this.$APICall(
      'get',
      'PASSWORD_RESET',
      '/action/' + this.$route.params.token,
      {},
      data => {
        vm.$i18n.locale = data.language
        vm.valid = data.success
        vm.initialLoad = true
      },
      true,
      error => {
        handle_session_error(error, this.$store, this.$router, this.$prompt)
      }
    )
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.forgot-button {
  cursor: pointer;
  color: #607d8b;
}

.fair-title {
  color: #607d8b;
}

.login-card {
  border: 2px solid #e8e8e8 !important;
}

.login-overlay {
  min-height: 720px;
  height: 100vh;
  width: 100vw;
  margin: -24px;
  text-align: center;
  padding: 0px;
  padding-top: 90px;
  color: #4b4b4b;
  background-color: #ffffff;
}

.login-inner {
  margin-left: auto;
  margin-right: auto;
  max-width: 556px;
}

.login-inner img {
  margin-bottom: 78px;
}
</style>
